import { Mail, Linkedin, GraduationCap, ExternalLink } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

export const Team = () => {
  const leadershipTeam = [
    {
      id: 1,
      name: 'Adam Arebi',
      role: 'President/Co-founder',
      major: 'Honors ECE Major',
      year: 'Sophomore',
      email: 'arebi.3@osu.edu',
      linkedin: 'https://www.linkedin.com/in/adam-arebi/',
      hasPhoto: true,
      photo: null,
      color: 'from-gray-100 to-gray-200'
    },
    {
      id: 2,
      name: 'Shareef Anani',
      role: 'Vice President/Co-founder',
      major: 'Honors ECE Major',
      year: 'Sophomore',
      email: 'anani.9@osu.edu',
      linkedin: 'https://www.linkedin.com/in/shareef-anani-17b251256',
      hasPhoto: true,
      photo: 'https://customer-assets.emergentagent.com/job_chip-design-hub-3/artifacts/ayaqror6_8396D294-8704-422C-8B56-762FBD1A6362_1_105_c.jpeg',
      color: 'from-red-100 to-red-200'
    },
    {
      id: 3,
      name: 'Kerem Çakmak',
      role: 'Outreach',
      major: 'Honors Finance & Math Major',
      year: 'Sophomore',
      email: 'cakmak.8@osu.edu',
      linkedin: 'https://www.linkedin.com/in/kecakmak/',
      hasPhoto: true,
      photo: 'https://customer-assets.emergentagent.com/job_chip-design-hub-3/artifacts/kjq4e5lq_1770145789648.jpeg',
      color: 'from-red-50 to-gray-100'
    },
    {
      id: 4,
      name: 'Jonathan Timmons',
      role: 'Treasurer',
      major: 'Honors ECE Major',
      year: 'Sophomore',
      email: 'timmons.192@osu.edu',
      linkedin: 'https://www.linkedin.com/in/jonathan-r-timmons/',
      hasPhoto: true,
      photo: 'https://customer-assets-lqy194kg.emergentagent.net/job_chip-design-hub-3/artifacts/hmc6fqjs_77C209B9-7005-4A69-AB48-FA78F59F6E03_1_201_a.jpeg',
      color: 'from-gray-100 to-red-100',
      isPlaceholder: false
    },
    {
      id: 5,
      name: 'Haithem Djouadi',
      role: 'Secretary',
      major: 'ECE Major',
      year: 'Sophomore',
      email: 'djouadi.5@osu.edu',
      linkedin: null,
      hasPhoto: true,
      photo: 'https://customer-assets-lqy194kg.emergentagent.net/job_chip-design-hub-3/artifacts/131xsdqw_02677C6C-E0E4-4191-8943-FFF976407E67.jpeg',
      color: 'from-gray-50 to-gray-150',
      isPlaceholder: false
    },
    {
      id: 6,
      name: 'Paul Runge',
      role: 'Technical Lead: Analog',
      major: 'ECE Major',
      year: 'Senior',
      email: 'runge.30@osu.edu',
      linkedin: 'https://www.linkedin.com/in/paul-runge1/',
      hasPhoto: true,
      photo: null,
      color: null,
      isPlaceholder: false
    },
    {
      id: 7,
      name: 'Sam Ellicott',
      role: 'Technical Lead: Digital Design',
      major: 'MS in ECE',
      year: 'Graduate Student',
      email: 'hooper.131@osu.edu',
      linkedin: 'https://www.linkedin.com/in/paul-runge1/',
      hasPhoto: true,
      photo: null,
      color: null,
      isPlaceholder: false
    },
    {
      id: 8,
      name: 'Mitchell Hooper',
      role: 'Supply Chain & Business Operations',
      major: 'Business Administration & Finance',
      year: 'Senior',
      email: 'hooper.131@osu.edu',
      linkedin: 'https://www.linkedin.com/in/paul-runge1/',
      hasPhoto: true,
      photo: null,
      color: null,
      isPlaceholder: false
    }
      
  ];

  return (
    <section id="team" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
            Meet The Board
          </h2>
          <div className="w-24 h-1 bg-[#BB0000] mx-auto mb-8"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Driven students leading the future of semiconductor innovation at Ohio State
          </p>
        </div>

        {/* Leadership Cards Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
          {leadershipTeam.map((member) => (
            <Card 
              key={member.id}
              className={`border-2 ${member.isPlaceholder ? 'border-[#BB0000]/30 bg-gradient-to-br from-red-50 to-white' : 'border-gray-200'} hover:border-[#BB0000] transition-all hover:shadow-2xl group overflow-hidden`}
            >
              <CardContent className="p-0">
                {member.hasPhoto && member.photo ? (
                  <div className="relative overflow-hidden h-64">
                    <img 
                      src={member.photo} 
                      alt={member.name}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  </div>
                ) : (
                  <div className={`relative overflow-hidden bg-gradient-to-br ${member.color} h-64 flex items-center justify-center`}>
                    <div className="text-center px-4">
                      {member.isPlaceholder ? (
                        <>
                          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#BB0000]/20 rounded-full mb-4">
                            <GraduationCap className="text-[#BB0000]" size={32} />
                          </div>
                          <p className="text-[#BB0000] font-bold text-lg mb-2">Position Available</p>
                          <p className="text-gray-600 font-semibold text-base">{member.role}</p>
                        </>
                      ) : (
                        <>
                          <GraduationCap className="text-gray-400 mx-auto mb-4" size={56} />
                          <p className="text-gray-600 font-bold text-base">{member.role}</p>
                        </>
                      )}
                    </div>
                  </div>
                )}
                
                <div className="p-5">
                  <h3 className={`text-lg font-bold mb-1 ${member.isPlaceholder ? 'text-[#BB0000]' : 'text-gray-900'}`}>
                    {member.name}
                  </h3>
                  <p className="text-[#BB0000] font-semibold mb-2 text-sm">{member.role}</p>
                  
                  {!member.isPlaceholder && (
                    <>
                      <div className="flex items-center gap-2 text-xs text-gray-600 mb-3">
                        <GraduationCap size={14} />
                        <span>{member.major} • {member.year}</span>
                      </div>
                      
                      <div className="mb-4 space-y-1">
                        <p className="text-xs text-gray-600 truncate" title={member.email}>
                          {member.email}
                        </p>
                      </div>
                    </>
                  )}

                  {member.isPlaceholder ? (
                    <>
                      <p className="text-sm text-gray-600 mb-4 italic">
                        {member.major}
                      </p>
                      <a 
                        href={member.applicationUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block"
                      >
                        <Button className="w-full bg-[#BB0000] hover:bg-[#990000] text-white transition-all hover:scale-105 group/btn">
                          Apply Now
                          <ExternalLink className="ml-2 group-hover/btn:translate-x-1 transition-transform" size={16} />
                        </Button>
                      </a>
                    </>
                  ) : (
                    <div className="flex gap-2">
                      {member.email && (
                        <a 
                          href={`mailto:${member.email}`}
                          className="p-2 bg-gray-100 hover:bg-[#BB0000] hover:text-white rounded-lg transition-colors"
                          title="Email"
                        >
                          <Mail size={16} />
                        </a>
                      )}
                      
                      {member.linkedin && (
                        <a 
                          href={member.linkedin}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="p-2 bg-gray-100 hover:bg-[#BB0000] hover:text-white rounded-lg transition-colors"
                          title="LinkedIn"
                        >
                          <Linkedin size={16} />
                        </a>
                      )}
                    </div>
                  )}
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};
